import React from "react";
import { BsDot } from "react-icons/bs";

import "./ResumeQuizStatus.scss";
import { useNavigate } from "react-router-dom";

export default function ResumeQuizStatus() {
  const navigate = useNavigate();
  return (
    <div className="resume_status_container">
      <h2 className="topic_title">General Embryology</h2>
      <div className="status_card">
        <h4 className="subject_title">Anatomy</h4>
        <h3 className="quiz_title">Developmental period 1,2,3 & 4</h3>
        <div className="status_info">
          <div className="questions_completed">10/20</div>
          <BsDot />
          <div className="attempted_date">
            Attempted on 16th Dec 2022, 05:05 PM
          </div>
        </div>
        <button
          className="button button_primary"
          onClick={() => navigate("/qbanks/1/topicIdxyz/playquiz")}
        >
          Resume QBank
        </button>
      </div>
    </div>
  );
}
